export default "__VITE_ASSET__RiUMlbUl__"